produtos.component('produtos.conteudos.aulaModalComponent', {
    templateUrl: 'produtos/produtoDetalhes/conteudos/aulaModal/aulaModal.html',
    controller: 'produtos.aulaModalController',
    controllerAs: '$modal',
    bindings: { config: '=' }
});

produtos.controller('produtos.aulaModalController', [ '$scope', 'coreLanguage', 'coreFb', function($scope, $text, $fb){
    const $ctrl = this;
    $scope.$text = $text;

    const formErrorsDefault = {
        nome:{},
        ordem:{},
        tipo: {}
    };

    $ctrl.onBlur = (field) => {
        if(!$ctrl.formErrors){ $ctrl.formErrors = angular.copy(formErrorsDefault); }

        $ctrl.formErrors[field] = {
            field: !$scope.formAula[field].$valid,
            hint: !$scope.formAula[field].$valid
        };
    };

    $ctrl.close=()=>{
        $ctrl.config.dados = {};
        $ctrl.config.show = false;
        $ctrl.selectedContent = false;
        $ctrl.file = {};
    };

    $ctrl.validateForm=()=>{

        $ctrl.validateForm=()=>{
            if($scope.formAula.$valid){
                $ctrl.config.confirm($ctrl.config.dados);
            }else{
                Object.keys(formErrorsDefault).forEach(key=>{ $ctrl.onBlur(key); });
            }
        };
    };

    $ctrl.addConteudo=()=>{
        if(!$ctrl.config.dados.conteudos){ $ctrl.config.dados.conteudos = []; }
        
        let obj = {};

        if($ctrl.config.dados.tipo === 'conteudo'){
            obj = {conteudo:'video'};
        }else if($ctrl.config.dados.tipo === 'quiz'){
            obj = {resposta:{}, opcoes:[]};
        }

        $ctrl.config.dados.conteudos.push(obj);

        $ctrl.selectedContent = $ctrl.config.dados.conteudos.length - 1;
    };

    $ctrl.deleteConteudo=(idx)=>{
        $ctrl.config.dados.conteudos.splice(idx, 1)
    };

    $ctrl.getIconType=(tipo)=>{
        if(!tipo){
            return;
        }

        return $text.contentOptions.find(opt => opt.value === tipo)?.icon || '';
    };

    $ctrl.deleteArquivo=(arquivos, idx)=>{       
        arquivos.splice(idx, 1);
    };

    $ctrl.downloadFile=(fileUrl, fileName)=>{
        $fb.storage.downloadBlob(fileUrl, fileName);
    };

    $ctrl.addArquivo=()=>{
        if(!$ctrl.config.dados.conteudos[$ctrl.selectedContent].arquivos){ $ctrl.config.dados.conteudos[$ctrl.selectedContent].arquivos = []; }
        $ctrl.config.dados.conteudos[$ctrl.selectedContent].arquivos.push({url: $ctrl.file.url, nome: $ctrl.file.nome});
        $ctrl.file = {};
    };

    $ctrl.uploadFile=(event)=>{
        $ctrl.loadingFile = true;

        $fb.storage.upload(`/arquivos_aulas/`, event.target.files[0]).then(url => {
            if(!$ctrl.file){ $ctrl.file = {}; }

            $ctrl.file.url = url;
            $ctrl.loadingFile=false;
        });

    };

    $ctrl.addQuestion=(questao)=>{
        if(!$ctrl.config.dados.conteudos[$ctrl.selectedContent].opcoes){ $ctrl.config.dados.conteudos[$ctrl.selectedContent].opcoes = []; }
        $ctrl.config.dados.conteudos[$ctrl.selectedContent].opcoes.push(questao);

        $ctrl.questao = null;
    };

    $ctrl.deleteOpcao=(opcoes, idx)=>{

        if($ctrl.config.dados.conteudos[$ctrl.selectedContent].resposta && $ctrl.config.dados.conteudos[$ctrl.selectedContent].resposta.idx >= 0){
            let respIdx = $ctrl.config.dados.conteudos[$ctrl.selectedContent].resposta.idx;

            if(respIdx === idx){
                $ctrl.config.dados.conteudos[$ctrl.selectedContent].resposta = {};
            }else if(respIdx>idx){
                $ctrl.config.dados.conteudos[$ctrl.selectedContent].resposta = {
                    idx: respIdx - 1,
                    descricao: ''
                };
            }
        }

        opcoes.splice(idx, 1);
    };

    $ctrl.setResposta=(idx)=>{
        if(!$ctrl.config.dados.conteudos[$ctrl.selectedContent].resposta){ $ctrl.config.dados.conteudos[$ctrl.selectedContent].resposta = {}; }
        $ctrl.config.dados.conteudos[$ctrl.selectedContent].resposta = {
            idx: idx,
            descricao: ''
        };
    };

}]);